import React from "react";

import PopupDownShortcutStyle from './PopupDownShortcut.module.css';
import {useAppContext} from "../../provider/appProvider";
import ShortcutElement from "../Shortcut/ShortcutElement";

const PopupDownShortcut = (props) => {
  const { shortcuts } = useAppContext();

  return (
    <div className={PopupDownShortcutStyle.container}>
      <span className={PopupDownShortcutStyle.title}>Raccourcis</span>
      <div className={PopupDownShortcutStyle.content}>
        {shortcuts && shortcuts.map((shortcut) => {
          return(
            <ShortcutElement
              key={shortcut.id}
              shortcut={shortcut}
              type={1}
            />
          )
        })}
      </div>
    </div>
  );
};

export default PopupDownShortcut;
